import { render, staticRenderFns } from "./StatOperatore.vue?vue&type=template&id=79541399&"
import script from "./StatOperatore.vue?vue&type=script&lang=ts&"
export * from "./StatOperatore.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports